import * as React from 'react';
import { Form, Field } from 'formik';
import * as Yup from 'yup';

import FormikForm from '~/lib/forms/FormikForm';
import Input from '~/common/controls/Input';
import { navigate } from '~/router';
import { emailRegExp } from "~/apps/shared/consts";

const LoginSchema = Yup.object().shape({
  email: Yup.string().trim().matches(emailRegExp, "Email address is not valid").required("Required"),
});

const ResetForm = ({ error, onSubmit, submitting, success }) => {
  return (
    <FormikForm
      initialValues={{
        email: '',
      }}
      onSubmit={(data) => onSubmit(LoginSchema.cast(data))}
      validationSchema={LoginSchema}
      render={() => {
        return (
          <Form className="form__cont form--reset">
            <div className="form--reset">
              <div className="form--reset__head">
                <a href="javascript:void(null)" className="btn btn--text btn--il" onClick={() => navigate('login')}><span className="i i-tri-l-fill" /> Back</a>
                <div className="head__title">Reset Password</div>
              </div>

              {!success ?
                <>
                  <Field name="email" label="Email Address" className="input input--lg" type="text"
                         component={Input}/>

                  {error && <div className="form__note">{error}</div>}
                  <button className="btn btn--prim btn--xlg fw" disabled={submitting} type="submit">
                    Send Reset Email
                  </button>
                </>
                : <>
                  <div className="note note--flex note--prim ">
                    <div className="note--flex__icon">
                      <span className="i i-check i-check-round-md" />
                    </div>
                    <div className="note--flex__text">
                      The reset email was sent successfully, please check your mailbox.
                    </div>
                  </div>
                </>
              }
            </div>
          </Form>
        );
      }}
    />
  );
};

export default ResetForm;
